// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pr-0";
export var animationContainer = "_pr-1";
export var itemPrice = "_pr-a";
export var itemizedContent = "_pr-9";
export var itemizedHeader = "_pr-7";
export var itemizedRow = "_pr-8";
export var itemizedSection = "_pr-6";
export var modalContent = "_pr-2";
export var orderName = "_pr-3";
export var refundOption = "_pr-4";
export var refundOptionsContainer = "_pr-5";
export var shippingLabel = "_pr-b";
export var totalRow = "_pr-c";